export const WEATHER_CODES = [
  'CLOUDY',
  'FOG',
  'ICE',
  'LIGHT_RAIN',
  'PARTLY_CLOUDY',
  'RAIN',
  'SNOW',
  'STORM',
  'SUNNY',
  'UNKNOWN'
] as const

export type WeatherCode = (typeof WEATHER_CODES)[number]

const isWeatherCode = (code: string): code is WeatherCode => {
  return (WEATHER_CODES as readonly string[]).includes(code)
}

export const mapToWeatherCode = (code: string): WeatherCode => {
  if (isWeatherCode(code)) {
    return code
  }

  return 'UNKNOWN'
}
